export const ERROR_TYPE_CONSTANTS = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
};
